import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

const HorizontalBarChart = ({ data, options, height }) => (
  <Bar data={data} options={options} height={height} />
);

HorizontalBarChart.defaultProps = {
  data: {},
  options: {},
  height: 100,
};

HorizontalBarChart.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  height: PropTypes.number,
};

export default HorizontalBarChart;
